import {useCallback, useEffect} from 'react';
import {useFieldArray, useFormContext} from 'react-hook-form';
import styled from 'styled-components';

import Testimonial from 'components/Testimonial';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex;
`;

const Add = styled.div`
  text-decoration: underline;
  font-size: 18px;
  color: ${({theme}) => theme.link.default};
  cursor: pointer;

  &:hover,
  &:focus {
    color: ${({theme}) => theme.link.hover};
  }

  &:active {
    color: ${({theme}) => theme.link.active};
  }
`;

const Item = styled.li`
  margin: 0 0 20px;
`;

const fieldDefaultValue = [];

const TestimonialList = ({
  name, addLabel = 'Add testimonial', rules,
}) => {
  const {
    errors, setError, clearErrors, watch,
  } = useFormContext();
  const {
    fields, append, remove,
  } = useFieldArray({
    name,
  });
  const field = watch(name, fieldDefaultValue);
  const add = useCallback(() => {
    append({});
  }, [append]);
  const del = useCallback((idx) => () => {
    remove(idx);
  }, [remove]);
  useEffect(() => {
    if (rules && rules.minItems > 0) {
      if (
        (!errors[name] || !errors[name].type === 'minItems')
        && field.filter((val) => val.value).length < rules.minItems
      ) {
        setError(name, {
          type: 'minItems',
          message: `You must have at least ${rules.minItems} item${rules.minItems > 1 ? 's' : ''}`,
        });
      } else if (
        errors[name]
        && errors[name].type === 'minItems'
        && field.filter((val) => val.value).length >= rules.minItems
      ) {
        clearErrors(name);
      }
    }
  }, [field, errors, rules, name, setError, clearErrors]);

  return (
    <Wrapper>
      <ol>
        {fields.map((item, idx) => (
          <Item key={item.id}>
            <Testimonial
              name={`${name}[${idx}]`}
              rules={rules}
              onRemove={del(idx)}
            />
          </Item>
        ))}
      </ol>
      <Add onClick={add}>{addLabel}</Add>
    </Wrapper>
  );
};

export default TestimonialList;
